import LegalLayout, { Section } from "./LegalLayout";

export default function CommercialTerms() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Commercial Terms"
      version="v1.0"
      effective="February 14, 2026"
    >
      <div
        className="border border-volt/40 bg-volt/5 p-4 text-volt text-sm leading-relaxed"
        data-testid="commercial-placeholder-notice"
      >
        These Commercial Terms are placeholder terms and should be reviewed by a qualified lawyer before
        launch.
      </div>

      <Section heading="1. Purpose" testid="commercial-purpose">
        <p>
          These Commercial Terms explain how platform fees, commissions, and commercial opportunity rules may
          apply when PITCHD facilitates sponsorships, brand partnerships, paid collaborations, or commercial
          introductions.
        </p>
      </Section>

      <Section heading="2. Platform-Originated Opportunities" testid="commercial-platform-originated">
        <p>
          A platform-originated opportunity means any sponsorship, partnership, paid collaboration, campaign,
          introduction, lead, or commercial relationship that is initiated, discovered, introduced, managed,
          messaged, tracked, or facilitated through PITCHD.
        </p>
      </Section>

      <Section heading="3. Platform Fees" testid="commercial-platform-fees">
        <p>
          Where a commercial relationship, sponsorship, partnership, or paid collaboration is initiated
          through introductions, marketplace functionality, platform messaging, lead generation tools,
          campaign workflows, or other features provided by PITCHD, PITCHD may be entitled to a facilitation
          fee, commission, subscription fee, marketplace fee, or transaction fee.
        </p>
      </Section>

      <Section heading="4. Fee Visibility" testid="commercial-fee-visibility">
        <p>
          Any applicable platform fees, commissions, or transaction fees should be displayed to users before
          a transaction is completed where technically possible.
        </p>
      </Section>

      <Section heading="5. Anti-Circumvention" testid="commercial-anti-circumvention">
        <p>
          Users agree not to intentionally avoid, bypass, or circumvent PITCHD for the purpose of avoiding
          applicable platform fees in relation to opportunities originated through PITCHD.
        </p>
      </Section>

      <Section heading="6. Protection Period" testid="commercial-protection-period">
        <p>
          Commission or fee obligations may apply to commercial relationships entered into within 12 months
          of an introduction, lead, campaign, or opportunity facilitated through PITCHD.
        </p>
      </Section>

      <Section heading="7. No Exclusivity" testid="commercial-no-exclusivity">
        <p>
          Unless separately agreed in writing, PITCHD does not require athletes, creators, brands, agents, or
          managers to work exclusively through PITCHD.
        </p>
      </Section>

      <Section heading="8. No Agency Relationship" testid="commercial-no-agency">
        <p>
          PITCHD is not acting as an exclusive representative, talent agent, sports agent, or legal
          negotiator unless separately agreed in writing.
        </p>
      </Section>

      <Section heading="9. Future Marketplace Terms" testid="commercial-future-marketplace">
        <p>
          Additional marketplace, payment, escrow, campaign, or payout terms may apply when PITCHD launches
          brand-side accounts, payment processing, or campaign marketplace features.
        </p>
      </Section>

      <Section heading="10. Contact" testid="commercial-contact">
        <p>
          For any questions about these Commercial Terms, contact{" "}
          <a className="text-volt" href="mailto:commercial@pitchdhq.com">commercial@pitchdhq.com</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
